import styled from 'styled-components';

export const StyledTabGroup = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 6px;
  border: 1px solid rgba(234, 236, 239, 1);
  background-color: rgba(255, 255, 255, 1);
  padding: 6px;
  overflow: auto;
  .ant-radio-group {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
  }
  margin-bottom: 24px;
  .ant-radio-button-wrapper {
    font-size: 16px;
    height: 40px;
    line-height: 38px;
    padding: 0 16px;
    color: ${({ theme }) => theme.palette.text.sidebar};
    border-color: ${({ theme }) => theme.palette.white};
    border-inline-start-width: 1px;
    &:not(:last-child) {
      margin-right: 1px;
    }
  }
  .ant-radio-button-wrapper:hover,
  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    border-radius: 6px;
    color: ${({ theme }) => theme.palette.secondary.main};
    border-color: ${({ theme }) => theme.palette.secondary.main};
    background-color: #f3fffc;
  }
  .ant-radio-button-wrapper:not(:first-child)::before {
    content: '';
    width: 0;
    height: 0;
  }
  .ant-radio-button-label {
    text-wrap: nowrap;
  }
`;
